import * as React from 'react';
// import { Link } from 'react-router-dom';

import { Menu } from 'semantic-ui-react';

interface MainHeaderState {
  activeItem: string | null;
}

export class MainHeader extends React.Component<{}, MainHeaderState> {
  public state: MainHeaderState = {
    activeItem: null
  };
  
  public render() {
    const { activeItem } = this.state;

    return (
      <Menu stackable={true}>
        <Menu.Item>
          <strong>React Dictionary</strong>
        </Menu.Item>

        <Menu.Item
          name="login"
          active={activeItem === 'login'}
          onClick={this.handleItemClick}
        >
          Login
        </Menu.Item>
      </Menu>
    );
  }

  private handleItemClick = (e: any, { name }: { name: string }) => {
    this.setState({ activeItem: name });
  };
}


// WEBPACK FOOTER //
// ./src/components/main-header.tsx